<template>
  <component :is="iconComponent" />
</template>

<script>
import IconHistory78px from "@/common/components/icons/IconHistory78px.vue";
import IconHistory53px from "@/common/components/icons/IconHistory53px.vue";

export default {
  components: {
    IconHistory78px,
    IconHistory53px
  },

  props: {
    iconSize: {
      type: Number,
      default: 78
    }
  },

  computed: {
    iconComponent() {
      const { iconSize } = this;
      return `icon-history-${iconSize}px`;
    }
  }
};
</script>
